export default __webpack_public_path__ + "media/zurb/img/legacy/plunk/apple-large-20b16408a46b8d586902f64d3a4bb32c.png";